import { createContext } from 'react';
import { Form } from '../types/Form';

export const FormContext = createContext<Form>({
    formData: undefined,
    formErrors: undefined,
    formPermissions: undefined,
    isValid: () => true,
    updateFields: () => null
});